import React from 'react';
import useConfettiAnimation from '../useConfettiAnimation';
var confettiDefaultCSS = {
  width: '100%',
  margin: '0 auto',
  position: 'fixed',
  height: '100%',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: 10000
};

var Confetti = function Confetti(_ref) {
  var _ref$customCSS = _ref.customCSS,
      customCSS = _ref$customCSS === void 0 ? confettiDefaultCSS : _ref$customCSS,
      onAnimationStart = _ref.onAnimationStart,
      className = _ref.className,
      dataTest = _ref['data-test'];

  var _useConfettiAnimation = useConfettiAnimation(onAnimationStart),
      renderCanvas = _useConfettiAnimation.renderCanvas,
      canvasRef = _useConfettiAnimation.canvasRef;

  return renderCanvas ? /*#__PURE__*/React.createElement("canvas", {
    ref: canvasRef,
    id: "confetti",
    style: customCSS,
    "data-test": dataTest,
    className: className,
    "aria-hidden": true
  }) : /*#__PURE__*/React.createElement(React.Fragment, null);
};

Confetti.displayName = 'Confetti';
export default Confetti;